import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteAwardLeads: (
  fetchContext: FetchContext,
  awardLeadId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardLeadId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/award-leads/${awardLeadId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete award leads'));
